import { render, staticRenderFns } from "./UserDashboard.vue?vue&type=template&id=eb04f20e&scoped=true&"
import script from "./UserDashboard.vue?vue&type=script&lang=js&"
export * from "./UserDashboard.vue?vue&type=script&lang=js&"
import style0 from "./UserDashboard.vue?vue&type=style&index=0&id=eb04f20e&prod&scoped=true&lang=css&"
import style1 from "./UserDashboard.vue?vue&type=style&index=1&id=eb04f20e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../Github/lmsv4_web_frontend_vue/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb04f20e",
  null
  
)

export default component.exports